// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "@charset \"UTF-8\";\n.timeline-box {\n  padding-top: 10px;\n  max-height: 500px;\n  overflow-y: scroll;\n}\n.timeline-box .list-group-item {\n  margin-bottom: 2px !important;\n}\n.timeline-box .item-description {\n  border: 1px solid #D3D3D3;\n  padding: 5px;\n  border-radius: 5px;\n  box-shadow: 1px 1px 5px #888888;\n  margin: 5px 0;\n  font-size: 14px;\n  cursor: pointer;\n}\n\n/* 隱藏scroll */\n.timeline-box::-webkit-scrollbar {\n  display: none;\n}", ""]);
// Exports
module.exports = exports;
